// ⚠️ Rejects reserved/test domains like example.com, test.com, etc.
// 🔗 Reference: https://datatracker.ietf.org/doc/html/rfc2606

export const forbiddenDomains = ['example.com', 'example.net', 'example.org'];
